<form class="form" [formGroup]="renditionForm" (ngSubmit)="submit()">
  <div id="main-form">
    <!-- Seccion AGENTE REFERENCIADOR -->
    <div class="item-section" *ngIf="this.isReferidoACobrar">
      <div class="title">
        <p class="heading-02-bold grey-900">Agente referenciador</p>
      </div>
      <!-- Content Nombre del agente -->
      <div class="content-section">
        <!-- Agente referido -->
        <div class="item-form">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">Nombre del agente</p>
          </div>
          <div class="origin-toggle-container">
            <qr-input-autocomplete
              [config]="sellerAgentAutocomplete"
              [isDisabled]="this.sellerAgentAutocomplete.options.length == 0"
              [value]="this.renditionForm.value.referredName"
              (selectedChange)="referredNameChange($event)"
              (click)="preventDefault($event)"
              class="dropdown"
              (blurChange)="
                this.renditionForm.get('sellerAgent')?.markAsTouched()
              "
              [hasError]="
                renditionForm.get('sellerAgent')?.touched &&
                renditionForm.get('sellerAgent')?.invalid
              "
            ></qr-input-autocomplete>
          </div>
        </div>
        <!-- Agente referido END -->
        <!-- ORIGEN -->
        <div class="item-form">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">Refirió al cliente</p>
          </div>
          <div class="origin-toggle-container">
            <qr-toggle
              [config]="originReferredToggle"
              (change)="onChangeOrigin($event)"
            ></qr-toggle>
          </div>
        </div>
        <!-- ORIGEN END -->
        <!-- ORIGEN DEL CLIENTE -->
        <div class="item-form">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">Origen del cliente</p>
          </div>
          <div class="origin-toggle-container">
            <qr-dropdown
              [config]="this.dropdownSellerClient"
              [selected]="this.renditionForm.value.referredClient"
              (change)="dropdownReferredClientChange($event)"
              (blurChange)="
                this.renditionForm.get('referredClient')?.markAsTouched()
              "
              [hasError]="
                renditionForm.get('referredClient')?.touched &&
                renditionForm.get('referredClient')?.invalid
              "
              [isDisabled]="this.dropdownSellerClient.options.length == 0"
            ></qr-dropdown>
          </div>
        </div>
        <!-- ORIGEN DEL CLIENTE END -->
      </div>
    </div>
    <!-- Seccion AGENTE REFERENCIADOR end -->

    <!-- Seccion PROPIEDAD -->
    <div class="item-section" *ngIf="!this.isCuota">
      <div class="title">
        <p class="heading-02-bold grey-900">Propiedad</p>
      </div>
      <!-- Content PROPIEDAD -->
      <div class="content-section">
        <!-- ORIGEN -->
        <div class="item-form" *ngIf="!this.isReferidoACobrar && !this.isEdit">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">Origen</p>
          </div>
          <div class="origin-toggle-container">
            <qr-toggle
              [isDisabled]="true"
              [config]="originToggle"
              (change)="onChangeOrigin($event)"
            ></qr-toggle>
          </div>
        </div>
        <!-- ORIGEN END -->

        <!-- DIRECCION-->
        <div class="item-form">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">Dirección</p>
          </div>
          <div class="direction-container">
            <ng-container *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
              <qr-input
                class="input-autocomplete"
                [config]="inputDirectionNew"
                [value]="this.renditionForm.value.address"
                (valueChange)="changeInputDirectionNew($event)"
                [isDisabled]="
                  originToggle.viewValues[originToggle.optionSelected] ==
                    'Reserva' || this.isCaptchmentLite
                "
                (blurChange)="
                  this.renditionForm.get('address')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('address')?.touched &&
                  renditionForm.get('address')?.invalid
                "
              ></qr-input
            ></ng-container>
            <ng-container *ifNodeShow="[NODE_DO]">
              <qr-input
                class="input-autocomplete"
                [config]="inputDirectionNew"
                [value]="this.renditionForm.value.address"
                (valueChange)="changeInputDirectionNew($event)"
                [isDisabled]="
                  !this.isDirectionEmpty &&
                  (originToggle.viewValues[originToggle.optionSelected] ===
                    'Reserva' ||
                    this.isCaptchmentLite) &&
                  this.renditionForm.value.address
                "
                (blurChange)="
                  this.renditionForm.get('address')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('address')?.touched &&
                  renditionForm.get('address')?.invalid
                "
              ></qr-input>
            </ng-container>
            <qr-button
              *ngIf="this.reservation && !this.isEdit"
              id="clean-direction"
              [config]="buttonCleanDirection"
              (click)="onCleanDirection($event)"
            ></qr-button>
          </div>
        </div>
        <!-- DIRECCION END -->

        <!-- MLSID-->
        <div class="item-form">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">MLS-ID</p>
          </div>
          <div class="mlsid-container">
            <ng-container *ifNodeShow="[NODE_AR]">
              <div id="input-mlsid-first">
                <qr-input
                  [config]="inputMlsidFirst"
                  [value]="this.renditionForm.value.mlsidFirst"
                  (valueChange)="changeInputMlsIdFirst($event)"
                  (keydown)="isValidNumberMlsId($event)"
                  [isDisabled]="this.isEdit || this.isCaptchmentLite"
                  (blurChange)="
                    this.renditionForm.get('mlsidFirst')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('mlsidFirst')?.touched &&
                    renditionForm.get('mlsidFirst')?.invalid
                  "
                ></qr-input>
              </div>
              <span>-</span>
              <div id="input-mlsid-last">
                <qr-input
                  [config]="inputMlsidLast"
                  [value]="this.renditionForm.value.mlsidLast"
                  (valueChange)="changeInputMlsIdLast($event)"
                  (keydown)="isValidNumberMlsId($event)"
                  [isDisabled]="this.isEdit || this.isCaptchmentLite"
                  (blurChange)="
                    this.renditionForm.get('mlsidLast')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('mlsidLast')?.touched &&
                    renditionForm.get('mlsidLast')?.invalid
                  "
                ></qr-input>
              </div>
            </ng-container>
            <ng-container *ifNodeShow="[NODE_GLOBAL, NODE_DO]">
              <div id="mlsid-global-container">
                <qr-input
                  [config]="inputMlsidGlobal"
                  [value]="this.renditionForm.value.mlsidGlobal"
                  (valueChange)="changeInputMlsIdGlobal($event)"
                  (keydown)="isValidNumberMlsId($event)"
                  [isDisabled]="this.isEdit || this.isCaptchmentLite"
                  (blurChange)="
                    this.renditionForm.get('mlsidGlobal')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('mlsidGlobal')?.touched &&
                    renditionForm.get('mlsidGlobal')?.invalid
                  "
                ></qr-input>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- MLSID END -->

        <!-- TIPO DE PROPIEDAD-->
        <div class="item-form">
          <div class="item-label">
            <p class="subheading-01-semi-bold grey-800">Tipo de propiedad</p>
          </div>
          <div class="dropdown-standard-container">
            <qr-dropdown
              [config]="this.dropdownPropertiesType"
              (change)="dropdownPropertiesTypeChange($event)"
              [selected]="this.renditionForm.value.propertyType"
              (blurChange)="
                this.renditionForm.get('propertyType')?.markAsTouched()
              "
              [hasError]="
                renditionForm.get('propertyType')?.touched &&
                renditionForm.get('propertyType')?.invalid
              "
            ></qr-dropdown>
          </div>
        </div>
        <!-- TIPO DE PROPIEDAD END -->
      </div>
      <!-- Content PROPIEDAD END -->
    </div>
    <!-- Seccion PROPIEDAD END -->

    <!-- Seccion OPERACION -->
    <div class="item-section">
      <div class="title">
        <p class="heading-02-bold grey-900">Datos de la operación</p>
      </div>
      <!-- Content OPERACION -->
      <div class="content-section">
        <!-- AGREGAR CUOTA -->
        <ng-container *ngIf="this.isCuota && this.renditionFromBE">
          <!-- Rendición ID: -->
          <div class="item-form">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Rendición ID:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{
                  this.renditionFromBE.renditionId
                    ? this.renditionFromBE.renditionId
                    : this.renditionFromBE.id
                }}
              </p>
            </div>
          </div>
          <!-- Dirección: -->
          <div class="item-form">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Dirección:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.propertyAddress }}
              </p>
            </div>
          </div>
          <!-- MLS-ID: -->
          <div class="item-form">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">MLS-ID:</p>
              <p
                class="cuota-right caption-01-semi-bold grey-800"
                *ngIf="
                  this.renditionFromBE.mlsId != 'null-null' &&
                    this.renditionFromBE.mlsId != 'undefined-undefined';
                  else nomlsid
                "
              >
                {{ this.renditionFromBE.mlsId }}
              </p>
              <ng-template #nomlsid>
                <p class="cuota-right caption-01-semi-bold grey-800">-</p>
              </ng-template>
            </div>
          </div>
          <!-- Tipo de propiedad: -->
          <div class="item-form">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Tipo de propiedad:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.propertyTypeTxt }}
              </p>
            </div>
          </div>
          <!-- Fecha de la rendición: -->
          <div class="item-form" *ngIf="!this.isEdit">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Fecha de la rendición:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.renditionDate }}
              </p>
            </div>
          </div>
          <!-- Tipo de operación: -->
          <div class="item-form">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Tipo de operación:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.operationTypeTxt }}
              </p>
              <p class="cuota-double caption-01-regular grey-600">Crédito:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.credit ? "Si" : "No" }}
              </p>
            </div>
          </div>
          <!-- Jurisdicción: -->
          <div class="item-form right">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Jurisdicción:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.jurisdictionTxt }}
              </p>
            </div>
          </div>
          <!-- Compartida con: -->
          <div class="item-form">
            <div class="item-cuota">
              <p class="caption-01-regular grey-600">Compartida con:</p>
              <p class="cuota-right caption-01-semi-bold grey-800">
                {{ this.renditionFromBE.sharedByTxt }}
              </p>
              <p
                class="cuota-double caption-01-regular grey-600"
                *ngIf="this.renditionFromBE.sharedByTxt != 'Dos puntas'"
              >
                Oficina:
                {{
                  this.renditionFromBE.sharedBy == 3
                    ? "Otra inmobiliaria"
                    : "RE/MAX"
                }}
              </p>
              <p
                class="cuota-right caption-01-semi-bold grey-800"
                *ngIf="this.renditionFromBE.sharedByTxt != 'Dos puntas'"
              >
                {{
                  this.renditionFromBE.sharedBy == 3
                    ? this.renditionFromBE.otherRealEstate?.name
                    : this.renditionFromBE.sharedAgencyName
                }}
              </p>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="statisticsComputationField"></ng-container>
          <!-- FECHA -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Fecha de la cuota</p>
            </div>
            <div id="date-picker-container">
              <qr-date-picker
                class="date-picker"
                [config]="datePicker"
                (datepickerChange)="datepickerChange($event)"
                (blurChange)="this.renditionForm.get('date')?.markAsTouched()"
                [hasError]="
                  renditionForm.get('date')?.touched &&
                  renditionForm.get('date')?.invalid
                "
              ></qr-date-picker>
            </div>
          </div>
          <!-- FECHA END -->
        </ng-container>
        <!-- AGREGAR CUOTA end -->
        <!-- FECHA -->
        <ng-container *ngIf="!this.isCuota">
          <div class="item-form flex row">
            <div>
              <div class="item-label">
                <p class="subheading-01-semi-bold grey-800">Fecha</p>
              </div>
              <div id="date-picker-container">
                <qr-date-picker
                  class="date-picker"
                  [config]="datePicker"
                  (datepickerChange)="datepickerChange($event)"
                  (blurChange)="this.renditionForm.get('date')?.markAsTouched()"
                  [hasError]="
                    renditionForm.get('date')?.touched &&
                    renditionForm.get('date')?.invalid
                  "
                ></qr-date-picker>
              </div>
              <p
                class="caption-01-regular date-warning"
                *ngIf="this.renditionForm.value.date > this.today"
              >
                Al ser una fecha posterior al periodo actual solo podrá guardar
                la rendición como borrador.
              </p>
            </div>

            <div class="banks-container" *ngIf="this.NODE === this.NODE_DO">
              <div class="item-label">
                <p class="subheading-01-semi-bold grey-800">
                  ¿Tiene comisiones pendientes?
                </p>
              </div>
              <qr-toggle
                id="toggle-pending-commissions"
                [config]="pendingCommissionsToggle"
                (change)="onChangePendingCommissions($event)"
              ></qr-toggle>
            </div>
          </div>
          <!-- FECHA END -->
          <!-- Tipo de operación -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Tipo de operación</p>
            </div>
            <div class="operation-toggle-container">
              <qr-toggle
                [config]="operationToggle"
                (change)="onChangeOperation($event)"
              ></qr-toggle>
            </div>
          </div>
          <!-- Tipo de operación END -->

          <!-- Crédito -->
          <div class="item-form flex row">
            <div>
              <div class="item-label">
                <p class="subheading-01-semi-bold grey-800">Crédito</p>
              </div>
              <div>
                <mat-slide-toggle
                  color="primary"
                  [checked]="this.renditionForm.value.credit"
                  (change)="creditChanged($event)"
                ></mat-slide-toggle>
              </div>
            </div>

            <div class="banks-container">
              <div class="item-label">
                <p class="subheading-01-semi-bold grey-800">
                  Bancos y garantías
                </p>
              </div>
              <qr-dropdown
                [isDisabled]="this.dropdownBanks.options.length == 0"
                [config]="this.dropdownBanks"
                [selected]="this.renditionForm.value.bank"
                (change)="dropdownBankChange($event)"
                (blurChange)="this.renditionForm.get('bank')?.markAsTouched()"
                [hasError]="
                  renditionForm.get('bank')?.touched &&
                  renditionForm.get('bank')?.invalid
                "
              ></qr-dropdown>
            </div>
          </div>
          <!-- Crédito END -->

          <!-- Período -->
          <div
            class="item-form"
            *ngIf="this.operationToggle.optionSelected != 0"
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Período</p>
            </div>
            <div id="periodo-container">
              <div id="periodo-input">
                <qr-input
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [hasError]="
                    renditionForm.get('rentInput')?.touched &&
                    renditionForm.get('rentInput')?.invalid
                  "
                  [value]="
                    (this.renditionForm.value.rentInput | number: '1.0-0') || 0
                  "
                  [config]="inputPeriodo"
                  (valueChange)="changeInputRentValue($event)"
                ></qr-input>
              </div>
              <div id="periodo-toggle">
                <qr-toggle
                  [config]="periodoToggle"
                  (change)="onChangeRentPeriodo($event)"
                ></qr-toggle>
              </div>
            </div>
          </div>
          <!-- Período END -->

          <!-- Jurisdicción -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Jurisdicción</p>
            </div>
            <div class="dropdown-standard-container">
              <qr-dropdown
                [config]="this.dropdownJurisdiction"
                [selected]="this.renditionForm.value.jurisdiction"
                (change)="dropdownJurisdictionChange($event)"
                (blurChange)="
                  this.renditionForm.get('jurisdiction')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('jurisdiction')?.touched &&
                  renditionForm.get('jurisdiction')?.invalid
                "
              ></qr-dropdown>
            </div>
          </div>
          <!-- Jurisdicción END -->

          <!-- Compartida con -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Compartida con</p>
            </div>
            <div class="operation-toggle-container">
              <qr-toggle
                [config]="sharedWithToggle"
                (change)="onChangeSharedWith($event)"
              ></qr-toggle>
            </div>
          </div>
          <!-- Compartida con END -->
          <ng-container *ngTemplateOutlet="statisticsComputationField"></ng-container>

          <!-- Oficina -->
          <div
            class="item-form"
            *ngIf="
              (this.sharedWithToggle.optionSelected == 1 &&
                !this.isReferidoACobrar) ||
              (this.isReferidoACobrar &&
                this.sharedWithToggle.optionSelected == 0)
            "
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Oficina</p>
            </div>
            <div class="dropdown-standard-container">
              <qr-input-autocomplete
                [config]="officeAutocomplete"
                [value]="this.renditionForm.value.sharedWithOffice"
                (selectedChange)="dropdownOfficeChange($event)"
                (click)="preventDefault($event)"
                class="dropdown"
                (blurChange)="
                  this.renditionForm.get('sharedWithOffice')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('sharedWithOffice')?.touched &&
                  renditionForm.get('sharedWithOffice')?.invalid
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Oficina END -->

          <!-- Inmobiliaria -->
          <div
            class="item-form"
            *ngIf="
              (this.sharedWithToggle.optionSelected == 2 &&
                !this.isReferidoACobrar) ||
              (this.isReferidoACobrar &&
                this.sharedWithToggle.optionSelected == 1)
            "
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Inmobiliaria</p>
            </div>
            <div id="inmobiliaria-container">
              <qr-search-autocomplete
                [config]="anotherRealEstateConfig"
                (click)="preventDefault($event)"
                (selected)="this.dropdownInmobiliariaChange($event)"
                (blurChange)="
                  this.renditionForm
                    .get('sharedWithAnotherRealEstate')
                    ?.markAsTouched()
                "
                [value]="this.renditionForm.value.sharedWithAnotherRealEstate"
                [hasError]="
                  renditionForm.get('sharedWithAnotherRealEstate')?.touched &&
                  renditionForm.get('sharedWithAnotherRealEstate')?.invalid
                "
              >
              </qr-search-autocomplete>
            </div>
          </div>
          <!-- Inmobiliaria END -->
        </ng-container>

        <!-- Precio de cierre -->
        <div class="close-price-container">
          <div class="item-form no-mg">
            <div class="item-label">
              <p
                *ngIf="
                  this.isRendition || this.isIngresoRelacionado || this.isCuota
                "
                class="subheading-01-semi-bold grey-800"
              >
                Precio de cierre
              </p>
              <p
                *ngIf="this.isReferidoACobrar"
                class="subheading-01-semi-bold grey-800"
              >
                Comisión agente referenciador
              </p>
            </div>
            <div id="close-price-items-container">
              <!-- TC -->
              <div class="close-price-item">
                <div class="cp-item-title">
                  <p
                    *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                    class="caption-01-bold grey-700"
                  >
                    TC
                  </p>
                  <p *ifNodeShow="[NODE_DO]" class="caption-02-bold grey-700">
                    Tasa de cambio
                  </p>

                  <qr-icon
                    *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                    id="tooltip-icon"
                    name="question-mark"
                    color="grey-600"
                    matTooltipPosition="above"
                    [matTooltip]="
                      'El tipo de cambio actual es $ ' +
                      (this.actualExchangeRate.toString() | number: '1.0-0')
                    "
                  ></qr-icon>
                  <qr-icon
                    *ifNodeShow="[NODE_DO]"
                    id="tooltip-icon"
                    name="question-mark"
                    color="grey-600"
                    matTooltipPosition="above"
                    [matTooltip]="
                      'La tasa de cambio actual es $ ' +
                      (this.actualExchangeRate.toString() | number: '1.0-0')
                    "
                  ></qr-icon>
                </div>
                <div id="cp-item-input-tc">
                  <qr-input
                    [config]="inputTC"
                    (keydown)="isValidDecimalNumber($event)"
                    (paste)="onPasteDecimalNumber($event)"
                    [value]="
                      (this.renditionForm.value.exchangeRate
                        | number: '1.0-2') || 0
                    "
                    (valueChange)="changeInputTC($event)"
                    (blurChange)="
                      this.renditionForm.get('exchangeRate')?.markAsTouched()
                    "
                    [isDisabled]="this.NODE === this.NODE_DO"
                    [hasError]="
                      renditionForm.get('exchangeRate')?.touched &&
                      renditionForm.get('exchangeRate')?.invalid
                    "
                  ></qr-input>
                </div>
              </div>
              <!-- U$S -->
              <div class="close-price-item">
                <div class="cp-item-title">
                  <p class="caption-01-bold grey-700">U$S</p>
                </div>
                <div class="cp-item-input">
                  <qr-input
                    [config]="inputClosePriceUSD"
                    (keydown)="isValidDecimalNumber($event)"
                    (paste)="onPasteDecimalNumber($event)"
                    [value]="
                      (this.renditionForm.value.closePriceUSD
                        | number: '1.0-2') || 0
                    "
                    (valueChange)="changeInputClosePriceUSD($event)"
                    (blurChange)="
                      this.renditionForm.get('closePriceUSD')?.markAsTouched()
                    "
                    [hasError]="
                      renditionForm.get('closePriceUSD')?.touched &&
                      renditionForm.get('closePriceUSD')?.invalid
                    "
                  ></qr-input>
                </div>
              </div>
              <!-- $ -->
              <div class="close-price-item">
                <div class="cp-item-title">
                  <p class="caption-01-bold grey-700">$</p>
                </div>
                <div class="cp-item-input">
                  <qr-input
                    [config]="inputClosePriceLocal"
                    (keydown)="isValidDecimalNumber($event)"
                    (paste)="onPasteDecimalNumber($event)"
                    [value]="
                      (this.renditionForm.value.closePriceLocal
                        | number: '1.0-2') || 0
                    "
                    (valueChange)="changeInputClosePriceLocal($event)"
                    (blurChange)="
                      this.renditionForm.get('closePriceLocal')?.markAsTouched()
                    "
                    [hasError]="
                      renditionForm.get('closePriceLocal')?.touched &&
                      renditionForm.get('closePriceLocal')?.invalid
                    "
                  ></qr-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Precio de cierre END -->
      </div>
      <!-- Content OPERACION END -->
    </div>
    <!-- Seccion OPERACION END -->

    <!-- Seccion Puntas -->
    <!-- Titulo -->
    <div class="flex" *ngIf="!this.isReferidoACobrar">
      <div class="item-section w-50 mr-16">
        <div class="title">
          <p *ifNodeShow="[NODE_DO]" class="heading-02-bold grey-900">
            Punta captadora
          </p>
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="heading-02-bold grey-900"
          >
            Punta vendedora
          </p>
        </div>
        <!-- Contenido -->
        <div class="content-section">
          <div class="puntas-items-container">
            <!-- % -->
            <div class="puntas-item">
              <div class="puntas-item-title">
                <p class="caption-01-bold grey-700">%</p>
              </div>
              <div id="puntas-item-input-percentage">
                <qr-input
                  [isDisabled]="
                    this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0
                  "
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [config]="inputTC"
                  [value]="
                    (this.renditionForm.value.sellerPercentage
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeInputSellerPercentage($event)"
                  (blurChange)="
                    this.renditionForm.get('sellerPercentage')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('sellerPercentage')?.touched &&
                    renditionForm.get('sellerPercentage')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
            <!-- U$S -->
            <div class="puntas-item">
              <div class="puntas-item-title">
                <p class="caption-01-bold grey-700">U$S</p>
              </div>
              <div class="puntas-item-input">
                <qr-input
                  [isDisabled]="
                    this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0
                  "
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [config]="inputClosePriceUSD"
                  [value]="
                    (this.renditionForm.value.sellerUSD | number: '1.0-2') || 0
                  "
                  (valueChange)="changeInputSellerUSD($event)"
                  (blurChange)="
                    this.renditionForm.get('sellerUSD')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('sellerUSD')?.touched &&
                    renditionForm.get('sellerUSD')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
            <!-- $ -->
            <div class="puntas-item">
              <div class="puntas-item-title">
                <p class="caption-01-bold grey-700">$</p>
              </div>
              <div class="puntas-item-input">
                <qr-input
                  [isDisabled]="
                    this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0
                  "
                  [config]="inputClosePriceLocal"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.sellerLocal | number: '1.0-2') ||
                    0
                  "
                  (valueChange)="changeInputSellerLocal($event)"
                  (blurChange)="
                    this.renditionForm.get('sellerLocal')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('sellerLocal')?.touched &&
                    renditionForm.get('sellerLocal')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
          </div>
        </div>
        <!-- Contenido END -->
      </div>

      <div class="item-section w-50">
        <!-- Titulo -->
        <div class="title">
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="heading-02-bold grey-900"
          >
            Punta compradora
          </p>
          <p *ifNodeShow="[NODE_DO]" class="heading-02-bold grey-900">
            Punta vendedora
          </p>
        </div>
        <!-- Contenido -->
        <div class="content-section">
          <div class="puntas-items-container">
            <!-- % -->
            <div class="puntas-item">
              <div class="puntas-item-title">
                <p class="caption-01-bold grey-700">%</p>
              </div>
              <div id="puntas-item-input-percentage">
                <qr-input
                  [isDisabled]="
                    this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0
                  "
                  [config]="inputTC"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.buyerPercentage
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeInputBuyerPercentage($event)"
                  (blurChange)="
                    this.renditionForm.get('buyerPercentage')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('buyerPercentage')?.touched &&
                    renditionForm.get('buyerPercentage')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
            <!-- U$S -->
            <div class="puntas-item">
              <div class="puntas-item-title">
                <p class="caption-01-bold grey-700">U$S</p>
              </div>
              <div class="puntas-item-input">
                <qr-input
                  [isDisabled]="
                    this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0
                  "
                  [config]="inputClosePriceUSD"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.buyerUSD | number: '1.0-2') || 0
                  "
                  (valueChange)="changeInputBuyerUSD($event)"
                  (blurChange)="
                    this.renditionForm.get('buyerUSD')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('buyerUSD')?.touched &&
                    renditionForm.get('buyerUSD')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
            <!-- $ -->
            <div class="puntas-item">
              <div class="puntas-item-title">
                <p class="caption-01-bold grey-700">$</p>
              </div>
              <div class="puntas-item-input">
                <qr-input
                  [isDisabled]="
                    this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0
                  "
                  [config]="inputClosePriceLocal"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.buyerLocal | number: '1.0-2') || 0
                  "
                  (valueChange)="changeInputBuyerLocal($event)"
                  (blurChange)="
                    this.renditionForm.get('buyerLocal')?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('buyerLocal')?.touched &&
                    renditionForm.get('buyerLocal')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
          </div>
        </div>
        <!-- Contenido END -->
      </div>
    </div>
    <!-- Seccion Puntas END -->

    <!-- Seccion Puntas RANGO -->
    <div class="item-section" *ngIf="!this.isReferidoACobrar">
      <div class="content-section">
        <!-- Slider -->
        <div id="slider-container">
          <div class="slider-item">
            <div class="slider-item-input">
              <qr-input
                [config]="inputClosePriceUSD"
                [isDisabled]="
                  this.isRelationFiftyFifty ||
                  (this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0)
                "
                (keydown)="isValidDecimalNumber($event)"
                (paste)="onPasteDecimalNumber($event)"
                [value]="
                  (this.renditionForm.value.sellerRelation | number: '1.0-2') ||
                  0
                "
                (valueChange)="changeInputSellerRelation($event)"
                (blurChange)="
                  this.renditionForm.get('sellerRelation')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('sellerRelation')?.touched &&
                  renditionForm.get('sellerRelation')?.invalid
                "
              ></qr-input>
            </div>
            <div class="slider-item-title">
              <p *ifNodeShow="[NODE_DO]" class="caption-02-regular grey-400">
                % Captador
              </p>
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="caption-02-regular grey-400"
              >
                % Vendedor
              </p>
            </div>
          </div>
          <div id="slider">
            <ngx-slider
              [(value)]="this.buyerRelation"
              [options]="sliderOptions"
              (valueChange)="rangeFromRelation($event)"
            ></ngx-slider>
          </div>
          <div class="slider-item">
            <div class="slider-item-input">
              <qr-input
                [config]="inputClosePriceUSD"
                [isDisabled]="
                  this.isRelationFiftyFifty ||
                  (this.renditionForm.value.closePriceLocal == 0 &&
                    this.renditionForm.value.closePriceUSD == 0)
                "
                (keydown)="isValidDecimalNumber($event)"
                (paste)="onPasteDecimalNumber($event)"
                [value]="
                  (this.renditionForm.value.buyerRelation | number: '1.0-2') ||
                  0
                "
                (valueChange)="changeInputBuyerRelation($event)"
                (blurChange)="
                  this.renditionForm.get('buyerRelation')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('buyerRelation')?.touched &&
                  renditionForm.get('buyerRelation')?.invalid
                "
              ></qr-input>
            </div>
            <div class="slider-item-title">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="caption-02-regular grey-400"
              >
                % Comprador
              </p>
              <p *ifNodeShow="[NODE_DO]" class="caption-02-regular grey-400">
                % Vendedor
              </p>
            </div>
          </div>
          <div
            id="lock-container"
            (click)="onRelationFiftyFifty(); preventDefault($event)"
          >
            <qr-icon
              *ngIf="this.isRelationFiftyFifty; else lockopen"
              name="lock-closed"
              color="primary-300"
            ></qr-icon>
            <ng-template #lockopen>
              <qr-icon name="lock-open" color="primary-100"></qr-icon>
            </ng-template>
          </div>
        </div>
        <!-- Slider END -->
      </div>
    </div>
    <!-- Seccion Puntas RANGO END -->

    <!-- Seccion Puntas -->
    <!-- Titulo -->
    <div class="flex sides-container" *ngIf="!this.isReferidoACobrar">
      <div class="item-section w-50 mr-16 sides-box">
        <div class="title space-between w-100">
          <p *ifNodeShow="[NODE_DO]" class="heading-02-bold grey-900">
            Agente captador
          </p>
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="heading-02-bold grey-900"
          >
            Agente vendedor
          </p>

          <div
            class="exclusive-container"
            *ngIf="this.renditionForm.value.sellerSharedWith == 'Mi oficina'"
          >
            <p class="paragraph-03-regular grey-800 mr-8">Exclusiva</p>
            <mat-slide-toggle
              color="primary"
              [checked]="this.renditionForm.value.exclusiveId == 1"
              (change)="onChangeExclusive($event)"
              [disabled]="this.isCuota"
            ></mat-slide-toggle>
          </div>
        </div>
        <!-- Contenido -->
        <div class="content-section">
          <!-- Origen -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Origen</p>
            </div>
            <div class="w-100">
              <qr-toggle
                [config]="sellerSharedWith"
                (change)="onChangeSellerSharedWith($event)"
                [isDisabled]="this.isCuota"
              ></qr-toggle>
            </div>
          </div>
          <!-- Origen END  -->
          <!-- Oficina -->
          <div
            class="item-form"
            *ngIf="this.sellerSharedWith.optionSelected != 2"
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Oficina</p>
            </div>
            <div class="w-100">
              <qr-input-autocomplete
                [config]="sellerOfficeAutocomplete"
                [isDisabled]="
                  this.sellerSharedWith.optionSelected != 1 || this.isCuota
                "
                [value]="this.renditionForm.value.sellerOffice"
                (selectedChange)="sellerOfficeAutocompleteChange($event)"
                (click)="preventDefault($event)"
                class="dropdown"
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Oficina END -->
          <!-- Otra inmobiliaria -->
          <div
            class="item-form"
            *ngIf="this.sellerSharedWith.optionSelected == 2"
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Inmobiliaria</p>
            </div>
            <div class="w-100">
              <qr-input-autocomplete
                [isDisabled]="true"
                [config]="sellerOtherRemaxAutocomplete"
                [value]="this.renditionForm.value.sharedWithAnotherRealEstate"
                class="dropdown"
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Otra inmobiliaria  END -->
          <!-- Nombre de agente -->
          <div
            class="item-form"
            *ngIf="
              this.sellerSharedWith.optionSelected != 2 &&
              !this.inputAgentGlobalSeller
            "
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Nombre agente</p>
            </div>
            <div class="w-100">
              <qr-input-autocomplete
                [config]="sellerAgentAutocomplete"
                [isDisabled]="
                  this.sellerAgentAutocomplete.options.length == 0 ||
                  (this.isCuota && this.sellerSharedWith.optionSelected != 0)
                "
                [value]="this.renditionForm.value.sellerAgent"
                (selectedChange)="
                  sellerAgentAutocompleteChange($event);
                  this.renditionForm.get('sellerAgent')?.markAsTouched()
                "
                (click)="preventDefault($event)"
                class="dropdown"
                [hasError]="
                  renditionForm.get('sellerAgent')?.touched &&
                  renditionForm.get('sellerAgent')?.invalid
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Nombre de agente END -->
          <!-- Nombre de agente OTRA INMOBILIARIA -->
          <div
            class="item-form"
            *ngIf="
              this.sellerSharedWith.optionSelected == 2 ||
              this.inputAgentGlobalSeller
            "
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Nombre agente</p>
            </div>
            <div class="w-100">
              <qr-input
                [config]="inputAgentOtherRealEstate"
                [value]="this.renditionForm.value.sellerAgent"
                (valueChange)="changeSellerAgentOther($event)"
                class="dropdown"
                [isDisabled]="this.isCuota"
              ></qr-input>
            </div>
          </div>
          <!-- Nombre de agente OTRA INMOBILIARIA END -->
          <!-- Co Broker -->
          <ng-container *ifNodeShow="[NODE_DO]">
            <div class="item-form" *ngIf="!this.addSellerReferred">
              <div class="item-dotted">
                <div class="item-label space-between w-100">
                  <p class="subheading-01-semi-bold grey-800">Co-Brokers</p>
                </div>

                <div class="w-100">
                  <qr-button
                    class="w-100"
                    [config]="buttonSellerAddCoBroker"
                    (click)="preventDefault($event); onSellerAddCoBroker()"
                  ></qr-button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Cobroker contenido -->
          <ng-container
            *ngFor="
              let coBroker of coBrokers;
              let i = index;
              trackBy: trackByCobroker
            "
          >
            <div class="item-form" *ngIf="this.coBrokers.length > 0">
              <div class="item-line">
                <div class="title-co-broker">
                  <p class="subheading-01-semi-bold grey-900">
                    Co-Broker #{{ i + 1 }}
                  </p>
                  <qr-button
                    [config]="buttonCleanSellerReferred"
                    (click)="onRemoveCoBroker($event, coBroker)"
                  ></qr-button>
                </div>

                <div class="seller-referred-content w-100">
                  <!-- Origen -->
                  <div class="item-form">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">Origen</p>
                    </div>
                    <div class="w-100">
                      <qr-toggle
                        class="referred-origin-toggle"
                        [config]="sellerCobrokerSharedWith[coBroker.id]"
                        (change)="
                          onChangeSellerCobrokerSharedWith($event, coBroker, i)
                        "
                      ></qr-toggle>
                    </div>
                  </div>
                  <!-- Origen END  -->
                  <!-- Oficina Cobroker Vendedor -->
                  <div
                    class="item-form"
                    *ngIf="
                      this.sellerCobrokerSharedWith[coBroker.id]
                        .optionSelected === 1
                    "
                  >
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">Oficina</p>
                    </div>
                    <div class="w-100">
                      <!-- fixear parte del form luego -->
                      <qr-input-autocomplete
                        [config]="sellerCobrokerOfficeAutocomplete[coBroker.id]"
                        [value]="
                          sellerCobrokers.at(i).get('sellerCobrokerOffice')
                            ?.value
                        "
                        (selectedChange)="
                          sellerCobrokerOfficeAutocompleteChange(
                            $event,
                            coBroker,
                            i
                          )
                        "
                        class="dropdown"
                        (blurChange)="
                          sellerCobrokers
                            .at(i)
                            .get('sellerCobrokerOffice')
                            ?.markAsTouched()
                        "
                        [hasError]="
                          sellerCobrokers.at(i).get('sellerCobrokerOffice')
                            ?.touched &&
                          sellerCobrokers.at(i).get('sellerCobrokerOffice')
                            ?.invalid
                        "
                      ></qr-input-autocomplete>
                    </div>
                  </div>
                  <!-- Oficina Cobroker Vendedor END  -->

                  <!-- Nombre de agente -->
                  <div
                    class="item-form"
                    *ngIf="
                      this.sellerCobrokerSharedWith[coBroker.id]
                        .optionSelected != 2
                    "
                  >
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">Nombre agente</p>
                    </div>
                    <div class="w-100">
                      <qr-input-autocomplete
                        [config]="sellerCobrokerAgentAutocomplete[coBroker.id]"
                        [isDisabled]="
                          this.sellerCobrokerAgentAutocomplete[coBroker.id]
                            .options.length == 0
                        "
                        [value]="
                          sellerCobrokers.at(i).get('sellerCobrokerName')?.value
                        "
                        (selectedChange)="
                          sellerCobrokerAgentAutocompleteChange($event, i)
                        "
                        class="dropdown"
                        (blurChange)="
                          sellerCobrokers
                            .at(i)
                            .get('sellerCobrokerName')
                            ?.markAsTouched()
                        "
                        [hasError]="
                          sellerCobrokers.at(i).get('sellerCobrokerName')
                            ?.touched &&
                          sellerCobrokers.at(i).get('sellerCobrokerName')
                            ?.invalid
                        "
                      ></qr-input-autocomplete>
                    </div>
                  </div>
                  <!-- Nombre de agente END -->
                  <!-- Input OTRO -->
                  <div
                    class="item-form"
                    *ngIf="
                      this.sellerCobrokerSharedWith[coBroker.id]
                        .optionSelected === 2
                    "
                  >
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">
                        Nombre agente, oficina o inmobiliaria
                      </p>
                    </div>
                    <div class="w-100">
                      <qr-input
                        [config]="inputSellerCobrokerOther[coBroker.id]"
                        [value]="
                          sellerCobrokers.at(i).get('sellerCobrokerName')?.value
                        "
                        (valueChange)="changeSellerCobrokerOther($event, i)"
                        class="dropdown"
                      ></qr-input>
                    </div>
                  </div>
                  <!-- Input OTRO END -->
                  <!-- Comision bruta -->
                  <div class="item-form no-mg">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">
                        Comisión bruta
                      </p>
                    </div>
                    <div class="w-100 flex">
                      <!-- U$S -->
                      <div class="referred-item">
                        <div class="referred-item-input">
                          <qr-input
                            [isDisabled]="
                              this.renditionForm.value.sellerUSD == 0 ||
                              !this.renditionForm.value.sellerAgent ||
                              (this.sellerCobrokerAgentAutocomplete[coBroker.id]
                                .options.length === 0 &&
                                this.sellerCobrokerSharedWith[coBroker.id]
                                  .optionSelected !== 2)
                            "
                            [config]="inputSellerCobrokerUSD[coBroker.id]"
                            (keydown)="isValidDecimalNumber($event)"
                            (paste)="onPasteDecimalNumber($event)"
                            [value]="
                              (sellerCobrokers.at(i).get('sellerCobrokerUSD')
                                ?.value | number: '1.0-2') || 0
                            "
                            (valueChange)="
                              changeInputSellerCobrokerUSD($event, i)
                            "
                            (blurChange)="
                              sellerCobrokers
                                .at(i)
                                .get('sellerCobrokerUSD')
                                ?.markAsTouched()
                            "
                            [hasError]="
                              sellerCobrokers.at(i).get('sellerCobrokerUSD')
                                ?.touched &&
                              sellerCobrokers.at(i).get('sellerCobrokerUSD')
                                ?.invalid
                            "
                          ></qr-input>
                        </div>
                        <div class="punreferredtas-item-title">
                          <p class="caption-02-bold grey-500 pl-8 mt-8">U$S</p>
                        </div>
                      </div>
                      <!-- $ -->
                      <div class="referred-item">
                        <div class="referred-item-input">
                          <qr-input
                            [isDisabled]="
                              this.renditionForm.value.sellerLocal == 0 ||
                              !this.renditionForm.value.sellerAgent ||
                              (this.sellerCobrokerAgentAutocomplete[coBroker.id]
                                .options.length === 0 &&
                                this.sellerCobrokerSharedWith[coBroker.id]
                                  .optionSelected !== 2)
                            "
                            [config]="inputSellerCobrokerLocal[coBroker.id]"
                            (keydown)="isValidDecimalNumber($event)"
                            (paste)="onPasteDecimalNumber($event)"
                            [value]="
                              (sellerCobrokers.at(i).get('sellerCobrokerLocal')
                                ?.value | number: '1.0-2') || 0
                            "
                            (valueChange)="
                              changeInputSellerCobrokerLocal($event, i)
                            "
                            (blurChange)="
                              sellerCobrokers
                                .at(i)
                                .get('sellerCobrokerLocal')
                                ?.markAsTouched()
                            "
                            [hasError]="
                              sellerCobrokers.at(i).get('sellerCobrokerLocal')
                                ?.touched &&
                              sellerCobrokers.at(i).get('sellerCobrokerLocal')
                                ?.invalid
                            "
                          ></qr-input>
                        </div>
                        <div class="referred-item-title">
                          <p class="caption-02-bold grey-500 pl-8 mt-8">$</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Comision bruta END -->
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Vendedor cobroker contenido -->
          <!-- Origen de cliente -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Origen de cliente</p>
            </div>
            <div class="w-100" *ifNodeHide="[NODE_DO]">
              <qr-dropdown
                [config]="this.dropdownSellerClient"
                [selected]="this.renditionForm.value.sellerClient"
                (change)="onSellerClientChange($event)"
                (blurChange)="
                  this.renditionForm.get('sellerClient')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('sellerClient')?.touched &&
                  renditionForm.get('sellerClient')?.invalid
                "
                [isDisabled]="this.isCuota"
              ></qr-dropdown>
            </div>
            <div class="w-100" *ifNodeShow="[NODE_DO]">
              <qr-input-autocomplete
                [config]="sellerClientDOAutocomplete"
                [value]="this.renditionForm.value.sellerClient"
                (selectedChange)="onSellerClientChange($event)"
                class="dropdown"
                (blurChange)="
                  this.renditionForm.get('sellerClient')?.markAsTouched()
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Origen de cliente END -->
          <!-- Referido vendedor -->
          <div class="item-form" *ngIf="this.coBrokers.length === 0">
            <div class="item-dotted">
              <div class="item-label space-between w-100">
                <p
                  *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                  class="subheading-01-semi-bold grey-800"
                >
                  Referido vendedor
                </p>
                <p
                  *ifNodeShow="[NODE_DO]"
                  class="subheading-01-semi-bold grey-800"
                >
                  Referido captador
                </p>
                <qr-button
                  *ngIf="this.addSellerReferred"
                  [config]="buttonCleanSellerReferred"
                  (click)="onCleanSellerReferred($event)"
                ></qr-button>
              </div>
              <div class="w-100" *ngIf="!this.addSellerReferred">
                <qr-button
                  class="w-100"
                  [config]="buttonSellerAddReferred"
                  (click)="onSellerAddReferred($event)"
                ></qr-button>
              </div>
              <!-- Vendedor referido contenido -->
              <div
                class="seller-referred-content w-100"
                *ngIf="this.addSellerReferred"
              >
                <!-- Origen -->
                <div class="item-form">
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Origen</p>
                  </div>
                  <div class="w-100">
                    <qr-toggle
                      class="referred-origin-toggle"
                      [config]="sellerReferredSharedWith"
                      [isDisabled]="this.sellerSharedWith.optionSelected != 0"
                      (change)="onChangeSellerReferredSharedWith($event)"
                    ></qr-toggle>
                  </div>
                </div>
                <!-- Origen END  -->
                <!-- Oficina Referido Vendedor -->
                <div
                  class="item-form"
                  *ngIf="this.sellerReferredSharedWith.optionSelected == 1"
                >
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Oficina</p>
                  </div>
                  <div class="w-100">
                    <qr-input-autocomplete
                      [config]="sellerReferredOfficeAutocomplete"
                      [value]="this.renditionForm.value.sellerReferredOffice"
                      (selectedChange)="
                        sellerReferredOfficeAutocompleteChange($event)
                      "
                      class="dropdown"
                      (blurChange)="
                        this.renditionForm
                          .get('sellerReferredOffice')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('sellerReferredOffice')?.touched &&
                        renditionForm.get('sellerReferredOffice')?.invalid
                      "
                    ></qr-input-autocomplete>
                  </div>
                </div>
                <!-- Oficina Referido Vendedor END  -->

                <!-- Nombre de agente -->
                <div
                  class="item-form"
                  *ngIf="
                    this.sellerReferredSharedWith.optionSelected != 2 &&
                    !this.inputAgentGlobalSellerReferred
                  "
                >
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Nombre agente</p>
                  </div>
                  <div class="w-100">
                    <qr-input-autocomplete
                      [config]="sellerReferredAgentAutocomplete"
                      [isDisabled]="
                        this.sellerReferredAgentAutocomplete.options.length == 0
                      "
                      [value]="this.renditionForm.value.sellerReferredName"
                      (selectedChange)="
                        sellerReferredAgentAutocompleteChange($event)
                      "
                      class="dropdown"
                      (blurChange)="
                        this.renditionForm
                          .get('sellerReferredName')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('sellerReferredName')?.touched &&
                        renditionForm.get('sellerReferredName')?.invalid
                      "
                    ></qr-input-autocomplete>
                  </div>
                </div>
                <!-- Nombre de agente END -->
                <!-- Input OTRO -->
                <div
                  class="item-form"
                  *ngIf="
                    this.sellerReferredSharedWith.optionSelected == 2 ||
                    this.inputAgentGlobalSellerReferred
                  "
                >
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">
                      Nombre agente, oficina o inmobiliaria
                    </p>
                  </div>
                  <div class="w-100">
                    <qr-input
                      [config]="inputSellerReferredOther"
                      [value]="this.renditionForm.value.sellerReferredName"
                      (valueChange)="changeSellerReferredOther($event)"
                      class="dropdown"
                    ></qr-input>
                  </div>
                </div>
                <!-- Input OTRO END -->
                <!-- Comision bruta -->
                <div class="item-form no-mg">
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Comisión bruta</p>
                  </div>
                  <div class="w-100 flex">
                    <div class="referred-item">
                      <div class="referred-item-input">
                        <qr-input
                          [isDisabled]="
                            (this.NODE != this.NODE_GLOBAL &&
                              this.sellerReferredAgentAutocomplete.options
                                .length == 0 &&
                              this.sellerReferredSharedWith.optionSelected ==
                                1) ||
                            !this.renditionForm.value.sellerReferredName
                          "
                          [config]="inputSellerReferredPercetage"
                          (keydown)="isValidDecimalNumber($event)"
                          (paste)="onPasteDecimalNumber($event)"
                          [value]="
                            (this.renditionForm.value.sellerReferredPercentage
                              | number: '1.0-2') || 0
                          "
                          (valueChange)="
                            changeInputSellerReferredPercentage($event)
                          "
                          (blurChange)="
                            this.renditionForm
                              .get('sellerReferredPercentage')
                              ?.markAsTouched()
                          "
                          [hasError]="
                            renditionForm.get('sellerReferredPercentage')
                              ?.touched &&
                            renditionForm.get('sellerReferredPercentage')
                              ?.invalid
                          "
                        ></qr-input>
                      </div>
                      <div class="referred-item-title">
                        <p class="caption-02-bold grey-500 pl-8 mt-8">%</p>
                      </div>
                    </div>
                    <!-- U$S -->
                    <div class="referred-item">
                      <div class="referred-item-input">
                        <qr-input
                          [isDisabled]="
                            this.renditionForm.value.sellerUSD == 0 ||
                            !this.renditionForm.value.sellerReferredName ||
                            (this.sellerReferredAgentAutocomplete.options
                              .length == 0 &&
                              this.sellerReferredSharedWith.optionSelected ==
                                1 &&
                              this.NODE != this.NODE_GLOBAL)
                          "
                          [config]="inputSellerReferredUSD"
                          (keydown)="isValidDecimalNumber($event)"
                          (paste)="onPasteDecimalNumber($event)"
                          [value]="
                            (this.renditionForm.value.sellerReferredUSD
                              | number: '1.0-2') || 0
                          "
                          (valueChange)="changeInputSellerReferredUSD($event)"
                          (blurChange)="
                            this.renditionForm
                              .get('sellerReferredUSD')
                              ?.markAsTouched()
                          "
                          [hasError]="
                            renditionForm.get('sellerReferredUSD')?.touched &&
                            renditionForm.get('sellerReferredUSD')?.invalid
                          "
                        ></qr-input>
                      </div>
                      <div class="punreferredtas-item-title">
                        <p class="caption-02-bold grey-500 pl-8 mt-8">U$S</p>
                      </div>
                    </div>
                    <!-- $ -->
                    <div class="referred-item">
                      <div class="referred-item-input">
                        <qr-input
                          [isDisabled]="
                            this.renditionForm.value.sellerLocal == 0 ||
                            !this.renditionForm.value.sellerReferredName ||
                            (this.sellerReferredAgentAutocomplete.options
                              .length == 0 &&
                              this.sellerReferredSharedWith.optionSelected ==
                                1 &&
                              this.NODE != this.NODE_GLOBAL)
                          "
                          [config]="inputSellerReferredLocal"
                          (keydown)="isValidDecimalNumber($event)"
                          (paste)="onPasteDecimalNumber($event)"
                          [value]="
                            (this.renditionForm.value.sellerReferredLocal
                              | number: '1.0-2') || 0
                          "
                          (valueChange)="changeInputSellerReferredLocal($event)"
                          (blurChange)="
                            this.renditionForm
                              .get('sellerReferredLocal')
                              ?.markAsTouched()
                          "
                          [hasError]="
                            renditionForm.get('sellerReferredLocal')?.touched &&
                            renditionForm.get('sellerReferredLocal')?.invalid
                          "
                        ></qr-input>
                      </div>
                      <div class="referred-item-title">
                        <p class="caption-02-bold grey-500 pl-8 mt-8">$</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Comision bruta END -->
              </div>
              <!-- Vendedor referido contenido -->
            </div>
          </div>
          <!-- Referido vendedor END -->

          <!-- Team leader -->
          <ng-container *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            <div
              class="item-form"
              *ngIf="
                this.user?.agency_name === this.renditionForm.value.sellerOffice
              "
            >
              <div class="item-dotted">
                <div class="item-label">
                  <p class="subheading-01-semi-bold grey-800">Team leader</p>
                  <qr-button
                    *ngIf="this.addSellerTeamLeader"
                    class="w-100"
                    [config]="buttonCleanSellerReferred"
                    (click)="onSellerRemoveTeamLeader($event)"
                  ></qr-button>
                </div>
                <div class="w-100" *ngIf="!this.addSellerTeamLeader">
                  <qr-button
                    class="w-100"
                    [config]="buttonSellerAddTeamLeader"
                    [isDisabled]="
                      isTeamLeaderBlockedByJoinDate(
                        this.renditionForm.value.sellerAgent
                      )
                    "
                    (click)="onSellerAddTeamLeader($event)"
                  ></qr-button>
                </div>
                <!-- Vendedor team leader contenido -->
                <div
                  class="seller-referred-content w-100"
                  *ngIf="this.addSellerTeamLeader"
                >
                  <!-- Nombre -->
                  <div class="item-form">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">Nombre</p>
                    </div>
                    <div class="w-100 caption-01-semi-bold grey-800">
                      <p>
                        {{
                          this.renditionForm.value.sellerTeamLeader
                            | truncate: [25]
                        }}
                      </p>
                    </div>
                  </div>
                  <!-- Nombre END  -->
                  <!-- Origen de la captación -->
                  <div class="item-form">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800 mr-8">
                        Origen de la captación
                      </p>
                      <qr-icon
                        matTooltip="Al seleccionar T. Member, el 100% de los puntos serán destinados para dicho agente. Al seleccionar Team Leader, se repartirán los puntos 50/50.

                  La información a completar debajo (comisión bruta) es para la liquidación monetaria (35% o 45%) y no afectará la distribución de puntos para los premios`"
                        name="alert-orange"
                        color="grey-500"
                      ></qr-icon>
                    </div>
                    <div class="w-100">
                      <qr-toggle
                        [config]="sellerTeamLeaderOrigin"
                        (change)="onChangeSellerTeamLeaderOrigin($event)"
                      ></qr-toggle>
                    </div>
                  </div>
                  <!-- Origen de la captación END -->
                  <!-- Comision bruta -->
                  <div class="item-form no-mg">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">
                        Comisión bruta
                      </p>
                    </div>
                    <div class="w-100 flex">
                      <!-- U$S -->
                      <div class="teamleader-item w-50 mr-16">
                        <div class="teamleader-item-input">
                          <qr-input
                            [config]="inputSellerReferredUSD"
                            (keydown)="isValidDecimalNumber($event)"
                            (paste)="onPasteDecimalNumber($event)"
                            [value]="
                              (this.renditionForm.value.sellerTeamLeaderUSD
                                | number: '1.0-2') || 0
                            "
                            (valueChange)="changeSellerTeamUSD($event)"
                            [isDisabled]="
                              this.renditionForm.value.sellerUSD === 0
                            "
                            (blurChange)="
                              this.renditionForm
                                .get('sellerTeamLeaderUSD')
                                ?.markAsTouched()
                            "
                            [hasError]="
                              renditionForm.get('sellerTeamLeaderUSD')
                                ?.touched &&
                              renditionForm.get('sellerTeamLeaderUSD')?.invalid
                            "
                          ></qr-input>
                        </div>
                        <div class="teamleader-item-title">
                          <p class="caption-02-bold grey-500 pl-8 mt-8">U$S</p>
                        </div>
                      </div>
                      <!-- $ -->
                      <div class="teamleader-item w-50">
                        <div class="teamleader-item-input">
                          <qr-input
                            [config]="inputSellerReferredLocal"
                            (keydown)="isValidDecimalNumber($event)"
                            (paste)="onPasteDecimalNumber($event)"
                            [value]="
                              (this.renditionForm.value.sellerTeamLeaderLocal
                                | number: '1.0-2') || 0
                            "
                            (valueChange)="changeSellerTeamLocal($event)"
                            [isDisabled]="
                              this.renditionForm.value.sellerLocal === 0
                            "
                            [hasError]="
                              renditionForm.get('sellerTeamLeaderLocal')
                                ?.touched &&
                              renditionForm.get('sellerTeamLeaderLocal')
                                ?.invalid
                            "
                            (blurChange)="
                              this.renditionForm
                                .get('sellerTeamLeaderLocal')
                                ?.markAsTouched()
                            "
                          ></qr-input>
                        </div>
                        <div class="teamleader-item-title">
                          <p class="caption-02-bold grey-500 pl-8 mt-8">$</p>
                        </div>
                      </div>
                    </div>
                    <!-- Comision bruta END -->
                  </div>
                  <!-- Vendedor team leader contenido -->
                </div>
              </div>
              <!-- Team leader END -->
            </div>
            <!-- Contenido END -->
          </ng-container>
        </div>
      </div>
      <!-- Seccion Puntas END -->
      <div class="item-section w-50 sides-box">
        <div class="title w-100">
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="heading-02-bold grey-900 mr-8"
          >
            Agente comprador
          </p>
          <p *ifNodeShow="[NODE_DO]" class="heading-02-bold grey-900 mr-8">
            Agente vendedor
          </p>

          <div class="exclusive-buyer-container">
            <p
              class="caption-02-bold grey-600"
              *ngIf="
                this.renditionForm.value.sharedWith == 'Dos puntas';
                else isother
              "
            >
              {{
                this.renditionForm.value.exclusiveId == 1
                  ? "Exclusiva"
                  : "No exclusiva"
              }}
            </p>
            <ng-template #isother>
              <p class="caption-02-bold grey-600">Búsqueda</p>
            </ng-template>
          </div>
        </div>
        <!-- Contenido -->
        <div class="content-section">
          <!-- Origen -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Origen</p>
            </div>
            <div class="w-100">
              <qr-toggle
                [config]="buyerSharedWith"
                (change)="onChangeBuyerSharedWith($event)"
                [isDisabled]="this.isCuota"
              ></qr-toggle>
            </div>
          </div>
          <!-- Origen END  -->
          <!-- Oficina -->
          <div
            class="item-form"
            *ngIf="this.buyerSharedWith.optionSelected != 2"
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Oficina</p>
            </div>
            <div class="w-100">
              <qr-input-autocomplete
                [config]="buyerOfficeAutocomplete"
                (click)="preventDefault($event)"
                [isDisabled]="
                  this.buyerSharedWith.optionSelected != 1 || this.isCuota
                "
                [value]="this.renditionForm.value.buyerOffice"
                (selectedChange)="buyerOfficeAutocompleteChange($event)"
                class="dropdown"
                (blurChange)="
                  this.renditionForm.get('buyerOffice')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('buyerOffice')?.touched &&
                  renditionForm.get('buyerOffice')?.invalid
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Oficina END -->
          <!-- Otra inmobiliaria -->
          <div
            class="item-form"
            *ngIf="this.buyerSharedWith.optionSelected == 2"
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Inmobiliaria</p>
            </div>
            <div class="w-100">
              <qr-input-autocomplete
                [isDisabled]="true"
                (click)="preventDefault($event)"
                [config]="buyerOtherRemaxAutocomplete"
                [value]="this.renditionForm.value.sharedWithAnotherRealEstate"
                class="dropdown"
                [hasError]="
                  renditionForm.get('sharedWithAnotherRealEstate')?.touched &&
                  renditionForm.get('sharedWithAnotherRealEstate')?.invalid
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Otra inmobiliaria  END -->
          <!-- Nombre de agente -->
          <div
            class="item-form"
            *ngIf="
              this.buyerSharedWith.optionSelected != 2 &&
              !this.inputAgentGlobalBuyer
            "
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Nombre agente</p>
            </div>
            <div class="w-100">
              <qr-input-autocomplete
                [config]="buyerAgentAutocomplete"
                [isDisabled]="
                  this.buyerAgentAutocomplete.options.length == 0 ||
                  (this.isCuota && this.buyerSharedWith.optionSelected != 0)
                "
                [value]="this.renditionForm.value.buyerAgent"
                (selectedChange)="
                  buyerAgentAutocompleteChange($event);
                  this.renditionForm.get('buyerAgent')?.markAsTouched()
                "
                class="dropdown"
                [hasError]="
                  renditionForm.get('buyerAgent')?.touched &&
                  renditionForm.get('buyerAgent')?.invalid
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Nombre de agente END -->
          <!-- Nombre de agente OTRA INMOBILIARIA -->
          <div
            class="item-form"
            *ngIf="
              this.buyerSharedWith.optionSelected == 2 ||
              this.inputAgentGlobalBuyer
            "
          >
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Nombre agente</p>
            </div>
            <div class="w-100">
              <qr-input
                [config]="inputAgentOtherRealEstate"
                [value]="this.renditionForm.value.buyerAgent"
                (valueChange)="changeBuyerAgentOther($event)"
                class="dropdown"
                [isDisabled]="this.isCuota"
              ></qr-input>
            </div>
          </div>
          <!-- Nombre de agente OTRA INMOBILIARIA END -->
          <!-- Origen de cliente -->
          <div class="item-form">
            <div class="item-label">
              <p class="subheading-01-semi-bold grey-800">Origen de cliente</p>
            </div>
            <div class="w-100" *ifNodeHide="[NODE_DO]">
              <qr-dropdown
                [config]="this.dropdownBuyerClient"
                [selected]="this.renditionForm.value.buyerClient"
                (change)="onBuyerClientChange($event)"
                (blurChange)="
                  this.renditionForm.get('buyerClient')?.markAsTouched()
                "
                [hasError]="
                  renditionForm.get('buyerClient')?.touched &&
                  renditionForm.get('buyerClient')?.invalid
                "
                [isDisabled]="this.isCuota"
              ></qr-dropdown>
            </div>
            <div class="w-100" *ifNodeShow="[NODE_DO]">
              <qr-input-autocomplete
                [config]="buyerClientDOAutocomplete"
                [value]="this.renditionForm.value.buyerClient"
                (selectedChange)="onBuyerClientChange($event)"
                class="dropdown"
                (blurChange)="
                  this.renditionForm.get('buyerClient')?.markAsTouched()
                "
              ></qr-input-autocomplete>
            </div>
          </div>
          <!-- Origen de cliente END -->
          <!-- Referido comprador -->
          <div class="item-form">
            <div class="item-dotted">
              <div class="item-label space-between w-100">
                <p
                  *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                  class="subheading-01-semi-bold grey-800"
                >
                  Referido comprador
                </p>
                <p
                  *ifNodeShow="[NODE_DO]"
                  class="subheading-01-semi-bold grey-800"
                >
                  Referido vendedor
                </p>
                <qr-button
                  *ngIf="this.addBuyerReferred"
                  [config]="buttonCleanBuyerReferred"
                  (click)="onCleanBuyerReferred($event)"
                ></qr-button>
              </div>
              <div class="w-100" *ngIf="!this.addBuyerReferred">
                <qr-button
                  class="w-100"
                  [config]="buttonBuyerAddReferred"
                  (click)="onBuyerAddReferred($event)"
                ></qr-button>
              </div>
              <!-- Comprador referido contenido -->
              <div
                class="seller-referred-content w-100"
                *ngIf="this.addBuyerReferred"
              >
                <!-- Origen -->
                <div class="item-form">
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Origen</p>
                  </div>
                  <div class="w-100">
                    <qr-toggle
                      class="referred-origin-toggle"
                      [config]="buyerReferredSharedWith"
                      [isDisabled]="this.buyerSharedWith.optionSelected != 0"
                      (change)="onChangeBuyerReferredSharedWith($event)"
                    ></qr-toggle>
                  </div>
                </div>
                <!-- Origen END  -->
                <!-- Oficina Referido Comprador -->
                <div
                  class="item-form"
                  *ngIf="this.buyerReferredSharedWith.optionSelected == 1"
                >
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Oficina</p>
                  </div>
                  <div class="w-100">
                    <qr-input-autocomplete
                      [config]="buyerReferredOfficeAutocomplete"
                      [value]="this.renditionForm.value.buyerReferredOffice"
                      (selectedChange)="
                        buyerReferredOfficeAutocompleteChange($event)
                      "
                      class="dropdown"
                      (blurChange)="
                        this.renditionForm
                          .get('buyerReferredOffice')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('buyerReferredOffice')?.touched &&
                        renditionForm.get('buyerReferredOffice')?.invalid
                      "
                    ></qr-input-autocomplete>
                  </div>
                </div>
                <!-- Oficina Referido Comprador END  -->

                <!-- Nombre de agente -->
                <div
                  class="item-form"
                  *ngIf="
                    this.buyerReferredSharedWith.optionSelected != 2 &&
                    !this.inputAgentGlobalBuyerReferred
                  "
                >
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Nombre agente</p>
                  </div>
                  <div class="w-100">
                    <qr-input-autocomplete
                      [config]="buyerReferredAgentAutocomplete"
                      [isDisabled]="
                        this.buyerReferredAgentAutocomplete.options.length == 0
                      "
                      [value]="this.renditionForm.value.buyerReferredName"
                      (selectedChange)="
                        buyerReferredAgentAutocompleteChange($event)
                      "
                      class="dropdown"
                      (blurChange)="
                        this.renditionForm
                          .get('buyerReferredName')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('buyerReferredName')?.touched &&
                        renditionForm.get('buyerReferredName')?.invalid
                      "
                    ></qr-input-autocomplete>
                  </div>
                </div>
                <!-- Nombre de agente END -->
                <!-- Input OTRO -->
                <div
                  class="item-form"
                  *ngIf="
                    this.buyerReferredSharedWith.optionSelected == 2 ||
                    this.inputAgentGlobalBuyerReferred
                  "
                >
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">
                      Nombre agente, oficina o inmobiliaria
                    </p>
                  </div>
                  <div class="w-100">
                    <qr-input
                      [config]="inputBuyerReferredOther"
                      [value]="this.renditionForm.value.buyerReferredName"
                      (valueChange)="changeBuyerReferredOther($event)"
                      class="dropdown"
                    ></qr-input>
                  </div>
                </div>
                <!-- Input OTRO END -->
                <!-- Comision bruta -->
                <div class="item-form no-mg">
                  <div class="item-label">
                    <p class="caption-01-semi-bold grey-800">Comisión bruta</p>
                  </div>
                  <div class="w-100 flex">
                    <div class="referred-item">
                      <div class="referred-item-input">
                        <qr-input
                          [isDisabled]="
                            (this.NODE != this.NODE_GLOBAL &&
                              this.buyerReferredAgentAutocomplete.options
                                .length == 0 &&
                              this.buyerReferredSharedWith.optionSelected ==
                                1) ||
                            !this.renditionForm.value.buyerReferredName
                          "
                          [config]="inputBuyerReferredPercetage"
                          (keydown)="isValidDecimalNumber($event)"
                          (paste)="onPasteDecimalNumber($event)"
                          [value]="
                            (this.renditionForm.value.buyerReferredPercentage
                              | number: '1.0-2') || 0
                          "
                          (valueChange)="
                            changeInputBuyerReferredPercentage($event)
                          "
                          (blurChange)="
                            this.renditionForm
                              .get('buyerReferredPercentage')
                              ?.markAsTouched()
                          "
                          [hasError]="
                            renditionForm.get('buyerReferredPercentage')
                              ?.touched &&
                            renditionForm.get('buyerReferredPercentage')
                              ?.invalid
                          "
                        ></qr-input>
                      </div>
                      <div class="referred-item-title">
                        <p class="caption-02-bold grey-500 pl-8 mt-8">%</p>
                      </div>
                    </div>
                    <!-- U$S -->
                    <div class="referred-item">
                      <div class="referred-item-input">
                        <qr-input
                          [isDisabled]="
                            this.renditionForm.value.buyerUSD == 0 ||
                            !this.renditionForm.value.buyerReferredName ||
                            (this.buyerReferredAgentAutocomplete.options
                              .length == 0 &&
                              this.buyerReferredSharedWith.optionSelected ==
                                1 &&
                              this.NODE != this.NODE_GLOBAL)
                          "
                          [config]="inputBuyerReferredUSD"
                          (keydown)="isValidDecimalNumber($event)"
                          (paste)="onPasteDecimalNumber($event)"
                          [value]="
                            (this.renditionForm.value.buyerReferredUSD
                              | number: '1.0-2') || 0
                          "
                          (valueChange)="changeInputBuyerReferredUSD($event)"
                          (blurChange)="
                            this.renditionForm.get('buyerUSD')?.markAsTouched()
                          "
                          [hasError]="
                            renditionForm.get('buyerUSD')?.touched &&
                            renditionForm.get('buyerUSD')?.invalid
                          "
                        ></qr-input>
                      </div>
                      <div class="punreferredtas-item-title">
                        <p class="caption-02-bold grey-500 pl-8 mt-8">U$S</p>
                      </div>
                    </div>
                    <!-- $ -->
                    <div class="referred-item">
                      <div class="referred-item-input">
                        <qr-input
                          [isDisabled]="
                            this.renditionForm.value.buyerLocal == 0 ||
                            !this.renditionForm.value.buyerReferredName ||
                            (this.buyerReferredAgentAutocomplete.options
                              .length == 0 &&
                              this.buyerReferredSharedWith.optionSelected ==
                                1 &&
                              this.NODE != this.NODE_GLOBAL)
                          "
                          [config]="inputBuyerReferredLocal"
                          (keydown)="isValidDecimalNumber($event)"
                          (paste)="onPasteDecimalNumber($event)"
                          [value]="
                            (this.renditionForm.value.buyerReferredLocal
                              | number: '1.0-2') || 0
                          "
                          (valueChange)="changeInputBuyerReferredLocal($event)"
                          (blurChange)="
                            this.renditionForm
                              .get('buyerReferredLocal')
                              ?.markAsTouched()
                          "
                          [hasError]="
                            renditionForm.get('buyerReferredLocal')?.touched &&
                            renditionForm.get('buyerReferredLocal')?.invalid
                          "
                        ></qr-input>
                      </div>
                      <div class="referred-item-title">
                        <p class="caption-02-bold grey-500 pl-8 mt-8">$</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Comision bruta END -->
              </div>
              <!-- Comprador referido contenido -->
            </div>
          </div>
          <!-- Referido vendedor END -->

          <!-- Team leader -->
          <ng-container *ifNodeShow="[NODE_AR, NODE_GLOBAL]">
            <div
              class="item-form"
              *ngIf="
                this.user?.agency_name === this.renditionForm.value.buyerOffice
              "
            >
              <div class="item-dotted">
                <div class="item-label">
                  <p class="subheading-01-semi-bold grey-800">Team leader</p>
                  <qr-button
                    *ngIf="this.addBuyerTeamLeader"
                    class="w-100"
                    [config]="buttonCleanBuyerReferred"
                    (click)="onBuyerRemoveTeamLeader()"
                  ></qr-button>
                </div>
                <div class="w-100" *ngIf="!this.addBuyerTeamLeader">
                  <qr-button
                    class="w-100"
                    [config]="buttonBuyerAddTeamLeader"
                    [isDisabled]="
                      isTeamLeaderBlockedByJoinDate(
                        this.renditionForm.value.buyerAgent
                      )
                    "
                    (click)="onBuyerAddTeamLeader($event)"
                  ></qr-button>
                </div>
                <!-- Vendedor team leader contenido -->
                <div
                  class="seller-referred-content w-100"
                  *ngIf="this.addBuyerTeamLeader"
                >
                  <!-- Nombre -->
                  <div class="item-form">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">Nombre</p>
                    </div>
                    <div class="w-100 caption-01-semi-bold grey-800">
                      <p>
                        {{
                          this.renditionForm.value.buyerTeamLeader
                            | truncate: [25]
                        }}
                      </p>
                    </div>
                  </div>
                  <!-- Nombre END  -->
                  <!-- Origen de la captación -->
                  <div class="item-form">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800 mr-8">
                        Origen del cliente
                      </p>
                      <qr-icon
                        matTooltip="Al seleccionar T. Member, el 100% de los puntos serán destinados para dicho agente. Al seleccionar Team Leader, se repartirán los puntos 50/50.

                  La información a completar debajo (comisión bruta) es para la liquidación monetaria (35% o 45%) y no afectará la distribución de puntos para los premios`"
                        name="alert-orange"
                        color="grey-500"
                      ></qr-icon>
                    </div>
                    <div class="w-100">
                      <qr-toggle
                        [config]="buyerTeamLeaderOrigin"
                        (change)="onChangeBuyerTeamLeaderOrigin($event)"
                      ></qr-toggle>
                    </div>
                  </div>
                  <!-- Origen de la captación END -->
                  <!-- Comision bruta -->
                  <div class="item-form no-mg">
                    <div class="item-label">
                      <p class="caption-01-semi-bold grey-800">
                        Comisión bruta
                      </p>
                    </div>
                    <div class="w-100 flex">
                      <!-- U$S -->
                      <div class="teamleader-item w-50 mr-16">
                        <div class="teamleader-item-input">
                          <qr-input
                            [config]="inputBuyerReferredUSD"
                            (keydown)="isValidDecimalNumber($event)"
                            (paste)="onPasteDecimalNumber($event)"
                            [value]="
                              (this.renditionForm.value.buyerTeamLeaderUSD
                                | number: '1.0-2') || 0
                            "
                            (valueChange)="changeBuyerTeamUSD($event)"
                            [isDisabled]="
                              this.renditionForm.value.buyerUSD === 0
                            "
                            [hasError]="
                              renditionForm.get('buyerTeamLeaderUSD')
                                ?.touched &&
                              renditionForm.get('buyerTeamLeaderUSD')?.invalid
                            "
                            (blurChange)="
                              this.renditionForm
                                .get('buyerTeamLeaderUSD')
                                ?.markAsTouched()
                            "
                          ></qr-input>
                        </div>
                        <div class="teamleader-item-title">
                          <p class="caption-02-bold grey-500 pl-8 mt-8">U$S</p>
                        </div>
                      </div>
                      <!-- $ -->
                      <div class="teamleader-item w-50">
                        <div class="teamleader-item-input">
                          <qr-input
                            [config]="inputBuyerReferredLocal"
                            (keydown)="isValidDecimalNumber($event)"
                            (paste)="onPasteDecimalNumber($event)"
                            [value]="
                              (this.renditionForm.value.buyerTeamLeaderLocal
                                | number: '1.0-2') || 0
                            "
                            (valueChange)="changeBuyerTeamLocal($event)"
                            [isDisabled]="
                              this.renditionForm.value.buyerLocal === 0
                            "
                            [hasError]="
                              renditionForm.get('buyerTeamLeaderLocal')
                                ?.touched &&
                              renditionForm.get('buyerTeamLeaderLocal')?.invalid
                            "
                            (blurChange)="
                              this.renditionForm
                                .get('buyerTeamLeaderLocal')
                                ?.markAsTouched()
                            "
                          ></qr-input>
                        </div>
                        <div class="teamleader-item-title">
                          <p class="caption-02-bold grey-500 pl-8 mt-8">$</p>
                        </div>
                      </div>
                    </div>
                    <!-- Comision bruta END -->
                  </div>
                  <!-- Comprador team leader contenido -->
                </div>
              </div>
              <!-- Team leader END -->
            </div>
            <!-- Contenido END -->
          </ng-container>
        </div>
      </div>
      <!-- Contenido END -->
    </div>

    <!-- Deducciones -->
    <div class="item-section">
      <div class="title">
        <p class="heading-02-bold grey-900">Deducciones</p>
      </div>
      <div class="content-section">
        <div
          class="table-agent-deduction-container"
          *ngIf="
            this.renditionForm.value.sellerSharedWith == 'Mi oficina' ||
            (this.isReferidoACobrar &&
              this.originReferredToggle.optionSelected == 0)
          "
        >
          <div class="table-deduction-title">
            <p
              *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
              class="subheading-01-semi-bold grey-900"
            >
              Agente vendedor: {{ this.renditionForm.value.sellerAgent }}
            </p>
            <p *ifNodeShow="[NODE_DO]" class="subheading-01-semi-bold grey-900">
              Agente captador: {{ this.renditionForm.value.sellerAgent }}
            </p>
            <qr-button
              *ngIf="!this.showSellerManualDeduction"
              class="standard-btn mr-24"
              [config]="buttonAddManualDeductionSeller"
              (click)="openSellerManualDeduction($event)"
            ></qr-button>
          </div>
          <div class="content-deductions">
            <p class="caption-01-semi-bold grey-800 w-100">
              Deducciones por jurisdicción al tipo de agente
            </p>
            <div class="inputs-deduction-container">
              <!-- TC -->
              <div class="deduction-tc">
                <qr-input
                  [isDisabled]="
                    (!this.isReferidoACobrar &&
                      this.renditionForm.value.sellerSharedWith !=
                        'Mi oficina') ||
                    (this.isReferidoACobrar &&
                      this.originReferredToggle.optionSelected == 1)
                  "
                  [config]="inputJurisdictionPercentage"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.sellerAgentDeductionPercentage
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeSellerAgentDeductionPercentage($event)"
                  (blurChange)="
                    this.renditionForm
                      .get('sellerAgentDeductionPercentage')
                      ?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('sellerAgentDeductionPercentage')
                      ?.touched &&
                    renditionForm.get('sellerAgentDeductionPercentage')?.invalid
                  "
                ></qr-input>
              </div>
              <!-- U$S -->
              <div class="deduction-item">
                <qr-input
                  [config]="inputJurisdictionDollar"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [isDisabled]="
                    (!this.isReferidoACobrar &&
                      this.renditionForm.value.sellerUSD == 0) ||
                    (this.isReferidoACobrar &&
                      this.renditionForm.value.closePriceUSD == 0)
                  "
                  [value]="
                    (this.renditionForm.value.sellerAgentDeductionUSD
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeSellerAgentDeductionUSD($event)"
                  (blurChange)="
                    this.renditionForm
                      .get('sellerAgentDeductionUSD')
                      ?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('sellerAgentDeductionUSD')?.touched &&
                    renditionForm.get('sellerAgentDeductionUSD')?.invalid
                  "
                ></qr-input>
              </div>
              <!-- $ -->
              <div class="deduction-item">
                <qr-input
                  [isDisabled]="
                    (!this.isReferidoACobrar &&
                      this.renditionForm.value.sellerLocal == 0) ||
                    (this.isReferidoACobrar &&
                      this.renditionForm.value.closePriceLocal == 0)
                  "
                  [config]="inputJurisdictionLocal"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.sellerAgentDeductionLocal
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeSellerAgentDeductionLocal($event)"
                  (blurChange)="
                    this.renditionForm
                      .get('sellerAgentDeductionLocal')
                      ?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('sellerAgentDeductionLocal')?.touched &&
                    renditionForm.get('sellerAgentDeductionLocal')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
            <div
              class="deduction-manual-container"
              *ngIf="this.showSellerManualDeduction"
            >
              <p class="caption-01-semi-bold grey-800 w-100">
                Deducciones manual
              </p>
              <div class="inputs-deduction-container space-between">
                <div class="flex">
                  <!-- Nombre -->
                  <div class="deduction-tc">
                    <qr-input
                      id="test"
                      [config]="inputJurisdictionManualName"
                      [value]="
                        this.renditionForm.value.sellerManualDeductionName
                      "
                      (valueChange)="changeSellerManualDeductionName($event)"
                      (blurChange)="
                        this.renditionForm
                          .get('sellerManualDeductionName')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('sellerManualDeductionName')
                          ?.touched &&
                        renditionForm.get('sellerManualDeductionName')?.invalid
                      "
                    ></qr-input>
                  </div>
                  <!-- U$S -->
                  <div class="deduction-item">
                    <qr-input
                      [config]="inputJurisdictionManualDollar"
                      [isDisabled]="
                        (!this.isReferidoACobrar &&
                          this.renditionForm.value.sellerUSD == 0) ||
                        (this.isReferidoACobrar &&
                          this.renditionForm.value.closePriceUSD == 0)
                      "
                      (keydown)="isValidDecimalNumber($event)"
                      (paste)="onPasteDecimalNumber($event)"
                      [value]="
                        (this.renditionForm.value.sellerManualDeductionUSD
                          | number: '1.0-2') || 0
                      "
                      (valueChange)="changeSellerManualDeductionUSD($event)"
                      (blurChange)="
                        this.renditionForm
                          .get('sellerManualDeductionUSD')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('sellerManualDeductionUSD')
                          ?.touched &&
                        renditionForm.get('sellerManualDeductionUSD')?.invalid
                      "
                    ></qr-input>
                  </div>
                  <!-- $ -->
                  <div class="deduction-item">
                    <qr-input
                      [config]="inputJurisdictionManualLocal"
                      [isDisabled]="
                        (!this.isReferidoACobrar &&
                          this.renditionForm.value.sellerLocal == 0) ||
                        (this.isReferidoACobrar &&
                          this.renditionForm.value.closePriceLocal == 0)
                      "
                      (keydown)="isValidDecimalNumber($event)"
                      (paste)="onPasteDecimalNumber($event)"
                      [value]="
                        (this.renditionForm.value.sellerManualDeductionLocal
                          | number: '1.0-2') || 0
                      "
                      (valueChange)="changeSellerManualDeductionLocal($event)"
                      (blurChange)="
                        this.renditionForm
                          .get('sellerManualDeductionLocal')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('sellerManualDeductionLocal')
                          ?.touched &&
                        renditionForm.get('sellerManualDeductionLocal')?.invalid
                      "
                    ></qr-input>
                  </div>
                </div>
                <div>
                  <qr-button
                    [config]="buttonDelete"
                    matTooltip="Borrar"
                    (click)="deleteSellerManualDeduction($event)"
                  ></qr-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Deduccion Agente Comprador  -->
        <div
          class="table-agent-deduction-container"
          *ngIf="
            this.renditionForm.value.buyerSharedWith == 'Mi oficina' ||
            (this.isReferidoACobrar &&
              this.originReferredToggle.optionSelected == 1)
          "
        >
          <div class="table-deduction-title">
            <p
              *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
              class="subheading-01-semi-bold grey-900"
            >
              Agente comprador: {{ this.renditionForm.value.buyerAgent }}
            </p>
            <p *ifNodeShow="[NODE_DO]" class="subheading-01-semi-bold grey-900">
              Agente vendedor: {{ this.renditionForm.value.buyerAgent }}
            </p>
            <qr-button
              *ngIf="!this.showBuyerManualDeduction"
              class="standard-btn mr-24"
              [config]="buttonAddManualDeductionBuyer"
              (click)="openBuyerManualDeduction(); preventDefault($event)"
            ></qr-button>
          </div>
          <div class="content-deductions">
            <p class="caption-01-semi-bold grey-800 w-100">
              Deducciones por jurisdicción al tipo de agente
            </p>
            <div class="inputs-deduction-container">
              <!-- TC -->
              <div class="deduction-tc">
                <qr-input
                  [isDisabled]="
                    (!this.isReferidoACobrar &&
                      this.renditionForm.value.buyerSharedWith !=
                        'Mi oficina') ||
                    (this.isReferidoACobrar &&
                      this.originReferredToggle.optionSelected == 0)
                  "
                  [config]="inputJurisdictionPercentage"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.buyerAgentDeductionPercentage
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeBuyerAgentDeductionPercentage($event)"
                  (blurChange)="
                    this.renditionForm
                      .get('buyerAgentDeductionPercentage')
                      ?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('buyerAgentDeductionPercentage')
                      ?.touched &&
                    renditionForm.get('buyerAgentDeductionPercentage')?.invalid
                  "
                ></qr-input>
              </div>
              <!-- U$S -->
              <div class="deduction-item">
                <qr-input
                  [config]="inputJurisdictionDollar"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [isDisabled]="
                    (!this.isReferidoACobrar &&
                      this.renditionForm.value.buyerUSD == 0) ||
                    (this.isReferidoACobrar &&
                      this.renditionForm.value.closePriceUSD == 0)
                  "
                  [value]="
                    (this.renditionForm.value.buyerAgentDeductionUSD
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeBuyerAgentDeductionUSD($event)"
                  (blurChange)="
                    this.renditionForm
                      .get('buyerAgentDeductionUSD')
                      ?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('buyerAgentDeductionUSD')?.touched &&
                    renditionForm.get('buyerAgentDeductionUSD')?.invalid
                  "
                ></qr-input>
              </div>
              <!-- $ -->
              <div class="deduction-item">
                <qr-input
                  [isDisabled]="
                    (!this.isReferidoACobrar &&
                      this.renditionForm.value.buyerLocal == 0) ||
                    (this.isReferidoACobrar &&
                      this.renditionForm.value.closePriceLocal == 0)
                  "
                  [config]="inputJurisdictionLocal"
                  (keydown)="isValidDecimalNumber($event)"
                  (paste)="onPasteDecimalNumber($event)"
                  [value]="
                    (this.renditionForm.value.buyerAgentDeductionLocal
                      | number: '1.0-2') || 0
                  "
                  (valueChange)="changeBuyerAgentDeductionLocal($event)"
                  (blurChange)="
                    this.renditionForm
                      .get('buyerAgentDeductionLocal')
                      ?.markAsTouched()
                  "
                  [hasError]="
                    renditionForm.get('buyerAgentDeductionLocal')?.touched &&
                    renditionForm.get('buyerAgentDeductionLocal')?.invalid
                  "
                ></qr-input>
              </div>
            </div>
            <div
              class="deduction-manual-container"
              *ngIf="this.showBuyerManualDeduction"
            >
              <p class="caption-01-semi-bold grey-800 w-100">
                Deducciones manual
              </p>
              <div class="inputs-deduction-container space-between">
                <div class="flex">
                  <!-- Nombre -->
                  <div class="deduction-tc">
                    <qr-input
                      [config]="inputJurisdictionManualName"
                      [value]="
                        this.renditionForm.value.buyerManualDeductionName
                      "
                      (valueChange)="changeBuyerManualDeductionName($event)"
                      (blurChange)="
                        this.renditionForm
                          .get('buyerManualDeductionName')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('buyerManualDeductionName')
                          ?.touched &&
                        renditionForm.get('buyerManualDeductionName')?.invalid
                      "
                    ></qr-input>
                  </div>
                  <!-- U$S -->
                  <div class="deduction-item">
                    <qr-input
                      [config]="inputJurisdictionManualDollar"
                      [isDisabled]="
                        this.renditionForm.value.buyerUSD == 0 ||
                        (this.isReferidoACobrar &&
                          this.renditionForm.value.closePriceUSD == 0)
                      "
                      (keydown)="isValidDecimalNumber($event)"
                      (paste)="onPasteDecimalNumber($event)"
                      [value]="
                        (this.renditionForm.value.buyerManualDeductionUSD
                          | number: '1.0-2') || 0
                      "
                      (valueChange)="changeBuyerManualDeductionUSD($event)"
                      (blurChange)="
                        this.renditionForm
                          .get('buyerManualDeductionUSD')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('buyerManualDeductionUSD')?.touched &&
                        renditionForm.get('buyerManualDeductionUSD')?.invalid
                      "
                    ></qr-input>
                  </div>
                  <!-- $ -->
                  <div class="deduction-item">
                    <qr-input
                      [config]="inputJurisdictionManualLocal"
                      [isDisabled]="
                        this.renditionForm.value.buyerLocal == 0 ||
                        (this.isReferidoACobrar &&
                          this.renditionForm.value.closePriceLocal == 0)
                      "
                      (keydown)="isValidDecimalNumber($event)"
                      (paste)="onPasteDecimalNumber($event)"
                      [value]="
                        (this.renditionForm.value.buyerManualDeductionLocal
                          | number: '1.0-2') || 0
                      "
                      (valueChange)="changeBuyerManualDeductionLocal($event)"
                      (blurChange)="
                        this.renditionForm
                          .get('buyerManualDeductionLocal')
                          ?.markAsTouched()
                      "
                      [hasError]="
                        renditionForm.get('buyerManualDeductionLocal')
                          ?.touched &&
                        renditionForm.get('buyerManualDeductionLocal')?.invalid
                      "
                    ></qr-input>
                  </div>
                </div>
                <div>
                  <qr-button
                    [config]="buttonDelete"
                    matTooltip="Borrar"
                    (click)="deleteBuyerManualDeduction($event)"
                  ></qr-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Deducciones END -->

    <!-- Facturas -->
    <div class="item-section">
      <div class="title space-between w-100">
        <p class="heading-02-bold grey-900">Facturas</p>
        <qr-button
          class="standard-btn mr-24"
          [config]="buttonAddInvoices"
          (click)="openDialogAddInvoices($event)"
        ></qr-button>
      </div>
      <!-- Content OPERACION -->
      <div class="content-section">
        <!-- Tabla INVOICES -->
        <div id="invoices-table">
          <!-- Table Header -->
          <div id="invoices-table-header">
            <app-table-header-new
              class="table-header"
              [tableHeader]="this.tableHeaderInvoices"
              [isCheckboxColumnVisible]="false"
            ></app-table-header-new>
          </div>
          <!-- Table Header END -->
          <!-- Content Invoices -->
          <div
            id="invoices-content"
            *ngIf="this.invoices.length > 0; else noinvoices"
          >
            <div
              class="invoice-item"
              *ngFor="let item of this.invoices; let i = index"
              [ngClass]="{
                'grey-50': i % 2 != 0
              }"
            >
              <div class="item-blank"></div>
              <div class="item-circle">
                <div
                  class="circle"
                  [ngClass]="{
                    'success-50': item.origin == OFFICE_CLIENT,
                    'turquoise-500': item.origin == AGENT_CLIENT,
                    'primary-900': item.origin == AGENT_OFFICE
                  }"
                ></div>
              </div>
              <div class="item-type">
                <p class="paragraph-02-regular grey-800">
                  {{ item.invoiceType }}
                </p>
              </div>
              <div class="item-number">
                <p class="paragraph-02-regular grey-800">
                  {{ item.number }}
                </p>
              </div>
              <div class="item-agent">
                <p class="paragraph-02-regular grey-800">
                  {{ item.agent || "-" }}
                </p>
              </div>
              <div class="item-name">
                <p class="paragraph-02-regular grey-800">
                  {{ item.name }}
                </p>
              </div>
              <div class="item-total">
                <p class="paragraph-02-regular grey-800">
                  {{ item.amountCurrency == "U$S" ? "U$S " : "$ " }}
                  {{ item.amount | number: "1.0-2" }}
                </p>
              </div>
              <div class="item-iva">
                <p class="paragraph-02-regular grey-800">
                  {{ item.ivaCurrency == "U$S" ? "U$S " : "$ " }}
                  {{ item.iva | number: "1.0-2" }}
                </p>
              </div>
            </div>
          </div>
          <!-- No invoices -->
          <ng-template #noinvoices>
            <div id="no-invoices">
              <p class="subheading-01-semi-bold grey-500">
                Ninguna factura cargada aún
              </p>
            </div>
          </ng-template>
        </div>
        <!-- Tabla INVOICES END -->
        <div id="invoice-legend">
          <div class="legend-item">
            <div class="circle success-50"></div>
            <p class="paragraph-02-regular grey-800">Oficina al cliente</p>
          </div>
          <div class="legend-item">
            <div class="circle turquoise-500"></div>
            <p class="paragraph-02-regular grey-800">Agente al cliente</p>
          </div>
          <div class="legend-item">
            <div class="circle primary-900"></div>
            <p class="paragraph-02-regular grey-800">Agente a la oficina</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Facturas END -->

    <!-- Notas -->
    <div class="item-section">
      <div class="title">
        <p class="heading-02-bold grey-900">Notas</p>
      </div>
      <div class="content-section">
        <p class="subheading-01-semi-bold w-100 grey-900">
          Notas de la reserva
        </p>
        <textarea disabled="true" class="textarea-notes" cols="30" rows="10">{{
          this.renditionForm.value.reservationNotes
        }}</textarea>
        <p class="subheading-01-semi-bold w-100 grey-900">
          Notas de la rendición
        </p>
        <textarea
          class="textarea-notes"
          cols="30"
          rows="10"
          (keyup)="changeRenditionNotes($event)"
        >
          {{ this.renditionForm.value.renditionNotes }}</textarea
        >
      </div>
    </div>
    <!-- Notas END -->

    <!-- Regalias oficina -->
    <div class="item-section" *ifNodeShow="[NODE_DO]">
      <div class="title">
        <p class="heading-02-bold grey-900">Regalias oficina</p>
      </div>
      <div class="content-section">
        <div class="space-between w-100">
          <p class="subheading-01-semi-bold grey-900">
            Regalias oficina de negocios a pagar a la regional
          </p>
          <mat-slide-toggle
            id="slider-regalias"
            color="primary"
            [checked]="isRegaliasChecked"
            (change)="regaliasChanged($event.checked)"
          ></mat-slide-toggle>
        </div>

        <div class="inputs-regalias-container">
          <!-- U$S -->
          <div class="regalias-item">
            <qr-input
              [config]="inputJurisdictionDollar"
              (keydown)="isValidDecimalNumber($event)"
              (paste)="onPasteDecimalNumber($event)"
              [isDisabled]="
                (!this.isReferidoACobrar &&
                  this.renditionForm.value.sellerUSD === 0) ||
                (this.isReferidoACobrar &&
                  this.renditionForm.value.closePriceUSD === 0) ||
                !this.isRegaliasChecked
              "
              [value]="
                (this.renditionForm.value.regaliasUSD | number: '1.0-2') || 0
              "
              (valueChange)="changeRegaliasUSD($event)"
              (blurChange)="
                this.renditionForm.get('regaliasUSD')?.markAsTouched()
              "
              [hasError]="
                renditionForm.get('regaliasUSD')?.touched &&
                renditionForm.get('regaliasUSD')?.invalid
              "
            ></qr-input>
          </div>
          <!-- $ -->
          <div class="regalias-item">
            <qr-input
              [isDisabled]="
                (!this.isReferidoACobrar &&
                  this.renditionForm.value.sellerLocal === 0) ||
                (this.isReferidoACobrar &&
                  this.renditionForm.value.closePriceLocal === 0) ||
                !this.isRegaliasChecked
              "
              [config]="inputJurisdictionLocal"
              (keydown)="isValidDecimalNumber($event)"
              (paste)="onPasteDecimalNumber($event)"
              [value]="
                (this.renditionForm.value.regaliasLocal | number: '1.0-2') || 0
              "
              (valueChange)="changeRegaliasLocal($event)"
              (blurChange)="
                this.renditionForm.get('regaliasLocal')?.markAsTouched()
              "
              [hasError]="
                renditionForm.get('regaliasLocal')?.touched &&
                renditionForm.get('regaliasLocal')?.invalid
              "
            ></qr-input>
          </div>
        </div>
        <p
          class="royalties-error"
          *ngIf="
            (this.renditionForm.get('regaliasLocal')?.touched &&
              this.renditionForm.get('regaliasLocal')?.invalid) ||
            (this.renditionForm.get('regaliasUSD')?.touched &&
              this.renditionForm.get('regaliasUSD')?.invalid)
          "
        >
          Los montos de regalias no pueden superar la comisión bruta de la
          oficina
        </p>
      </div>
    </div>
    <!-- Regalias oficina END -->
  </div>
</form>

<!-- Dialogo Agregar Facturas -->
<qr-dialog-full-screen
  [config]="dialogAddInvoice"
  (dialogChange)="onAddInvoices($event)"
></qr-dialog-full-screen>

<!-- Dialogo limpiar formulario (cuando elimina la dirección) -->
<qr-dialog
  [config]="dialogClearForm"
  (dialogChange)="dialogChangeClearForm($event)"
></qr-dialog>

<!-- Dialogo borrador creado -->
<qr-dialog
  [config]="dialogDraftCreated"
  (dialogChange)="dialogChangeDraftCreated($event)"
></qr-dialog>

<app-loader-full-screen
  *ngIf="this.waitingService"
  [message]="msgLoading"
></app-loader-full-screen>

<ng-template #statisticsComputationField>
  <div class="item-form" *ngIf="this.NODE === this.NODE_DO">
    <div class="item-label">
      <p class="subheading-01-semi-bold grey-800">Cómputo de estadísticas</p>
    </div>
    <div class="statistics-computation">
      <qr-toggle
        [config]="statisticsComputationToggle"
        (change)="onChangeStatisticsComputation($event)"
      ></qr-toggle>
      <div class="statistics-computation__hint">
        <qr-icon name="info" color="grey-500"></qr-icon>
        <p class="caption-01-regular grey-600">
          {{ statisticsComputationHint }}
        </p>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialogo Aviso de Modificacion en los topes para facturacion -->
<!-- (Se abre si modifica algun monto, habia facturas ingresadas y el monto de las facturas ahora no coincide con los nuevos topes)-->
<qr-dialog [config]="this.dialogWarningForInvalidCapsInvoices"></qr-dialog>

<qr-overlay [(isOverlayVisible)]="this.openOverlay" [config]="this.overlay">
  <app-rendition-update-invoices
    [isOnlyInvoices]="this.errorInOfficeCaps"
    (actionToDo)="onChangeDialogWarningInvoices($event)"
  >
  </app-rendition-update-invoices>
</qr-overlay>
